import { createContext } from 'react';
import { StateChangeType } from 'types';

export const StateChangeContext = createContext({
  stateChange: {} as StateChangeType,
  setStateChange: (stateChange: StateChangeType) => {},
});
